import { createFileRoute, Outlet } from '@tanstack/react-router'
import { productQueryOptions } from '../../../../features/catalog/queries'

export const Route = createFileRoute('/_app/products/$productId')({
  staticData: { crumb: 'product' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(productQueryOptions(params.productId)),
  component: Outlet,
})
